/* eslint-disable */

import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Card,  CardBody,  Col, Container, FormGroup, Label, Row, Table } from 'reactstrap';
import { PGMContext } from '~/context/PGMContext';
import { LoaderLista, LoaderMini } from '~/components/Loaders';
import Pagination from 'react-js-pagination';
import { ChevronLeftOutlined, ChevronRightOutlined, CloseOutlined, CloudDownloadOutlined, FirstPageOutlined, LastPageOutlined } from '@mui/icons-material';
import moment from 'moment';
import { Text } from '~/components/Text';
import { FiltroGeral } from '~/components/Filtros/FiltroGeral';
import { symbolPriceFormatter } from '~/helpers/price';
import { color } from '~/assets/styles/colors';
import InputAutoSelect from '~/components/InputAutoSelect';
import { ExtratoContext } from '~/context/ExtratoContext';
import { TextClick, TrStyled } from './styles';

export default function Detalhamento(props) {
	const {
		dataDetalhamento,
		loadingDetalhamento,
		getDetalhamentoParticipante,
		getDetalhamentoIndustria,
		getDetalhamentoRevenda,
		getExportDetalhamento,
		loaderDownload
	} = useContext(PGMContext);
	const {
		revendaHierarquiaList,
		getHierarquiaByDoc
	} = useContext(ExtratoContext);

	const { user, isMobile } = props;
	const [params, setParams] = useState({
		dateInit: moment().format('YYYY-MM-DD'),
		dateEnd: moment().format('YYYY-MM-DD'),
	});
	const [dataRange, setDataRange] = useState({
		dateInit: '',
		dateEnd: '',
	});
	const [loading, setLoading] = useState(false);

	const [pagina, setPagina] = useState(1);

	const [permissao, setPermissao] = useState('');

	const [inputValue, setInputValue] = useState('');
	const [timer, setTimer] = useState(null);
	const [filtroPesquisa, setFiltroPesquisa] = useState('')

	function handlerPagination(page) {
		setPagina(page);
	}


	const cleanFilter = () => {
		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		})

		setDataRange({
			dateInit: '',
			dateEnd: '',
		})
	};

	const inputChanged = e => {
		setPagina(1)
		setInputValue(e.target.value)
		clearTimeout(timer)

		const newTimer = setTimeout(() => {
			setFiltroPesquisa(e.target.value)
		}, 1000)

		setTimer(newTimer)
	}

	const downloadExcel = async () => {
		await getExportDetalhamento({page: 1, items: 10000,  data_transacao:`${params.dateInit}|${params.dateEnd}`, excelQuery: true}, permissao)
	};

	function formatarData(data) {
		if (moment(data, 'YYYY-MM-DD', true).isValid()) {
			return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY');
		}

		if (moment(data, 'DD/MM/YYYY', true).isValid()) {
			return data;
		}
		return 'Formato inválido';
	}


	const getDetalhamento = async () => {
		if(user.dados.permissoes.detalhamento_financeiro_revenda){
			await getDetalhamentoRevenda({page: pagina, items: 10, data_transacao:`${params.dateInit}|${params.dateEnd}`, documento: filtroPesquisa});
		}

		if(user.dados.permissoes.detalhamento_financeiro_participante || user.dados.permissoes.detalhamento_financeiro_industria){
			await getDetalhamentoParticipante({page: pagina, items: 10, data_transacao:`${params.dateInit}|${params.dateEnd}`, documento: filtroPesquisa});
		}
	};

	useEffect(() => {
		async function fetch(){
			await getDetalhamento();
		}
		if(params.dateInit && params.dateEnd){
			fetch()
		}
	}, [params]);

	useEffect(() => {
		async function fetch(){
			await getDetalhamento();
		}
		fetch()
   }, [pagina, filtroPesquisa]);

	useEffect(() => {
		if(user.dados.permissoes.detalhamento_financeiro_revenda){
			setPermissao('Revenda');
		}

		if(user.dados.permissoes.detalhamento_financeiro_participante){
			setPermissao('Participante');
		}

		if(user.dados.permissoes.detalhamento_financeiro_industria){
			setPermissao('Industria');
		}	
   }, []);

   	useEffect(() => {
		if(revendaHierarquiaList.length === 0){
			getHierarquiaByDoc(user.dados.documento)
		}
	}, []);

	const options = useMemo(() =>[{"documento": "","nome": "Todos"}, ...revendaHierarquiaList], [revendaHierarquiaList]);
	const selectedValue = options.find(opt => opt?.documento === inputValue) || null;

   const totalizadorList = [
		{
			color: color.softBlack,
			value: dataDetalhamento.total_bruto,
			title: "Total Bruto",
			textColor: 'white',
		},
		{
			color: color.softBlack,
			value: dataDetalhamento.total_liquido,
			title: user.dados.cargo.toLowerCase() === 'industria' ? "Recebimento Líquido Participante" : "Recebimento Líquido Distribuidor",
			textColor: 'white',
		},
			{
			color: color.yellow,
			value: dataDetalhamento.total_credito,
			title: "Crédito Gerado Revendas",
			textColor: "",
		},
	]

	return (
		<Container fluid>
			<Card
				style={{
					boxShadow: 'unset',
					borderRadius: '0px 18px 18px 18px',
				}}>
				<FiltroGeral
					setLoading={setLoading}
					setParams={setParams}
					setPagina={setPagina}
					showPaginaGrupo={false}
					dataRange={dataRange}
					setDataRange={setDataRange}
					nomeTela="Detalhamento"
				>
					{revendaHierarquiaList.length > 0 &&
					<div style={{maxWidth: "66%"}}>
						<FormGroup>
							<Label style={{ fontWeight: 'bold' }}>Filtrar por Revenda: </Label>
								<InputAutoSelect
									options={options}
									getOptionLabel={(item) => `${item?.documento  || ''}${item?.documento && item?.nome ? ' - ' : ''}${item?.nome  || ''}` || ''}
									isOptionEqualToValue={(option, valueSelect) => option?.documento === valueSelect}
									value={selectedValue}
									onChangeOption={(evt, select) => {
										inputChanged({target: {value: select?.documento}} || {target: {value: ''}})
									}}
								/>
						</FormGroup>

					</div>

					}
					<TextClick
						style={{ all: 'unset', marginLeft: '10px', float: 'right' }}
						role="button"
						onClick={() => cleanFilter()}>
						<CloseOutlined className="mr-1" />
						Limpar Filtros
					</TextClick>
					{loaderDownload
					?
						<TextClick
							style={{ all: 'unset', float: 'right' }}>
							<LoaderMini />
						</TextClick>

					:
							<TextClick
								style={{ all: 'unset', float: 'right' }}
								role="button"
								onClick={() => {
									downloadExcel()
								}}>
								<CloudDownloadOutlined className="mr-1" />
								Fazer Download
							</TextClick>
					}
				</FiltroGeral>
			</Card>

			<Row className="mt-5">
				{totalizadorList.map((item, index) => (
					<Col key={`${item.title}-${index}`}>
						<Text>{item.title}</Text>
						<Card
							style={{
								backgroundColor: item.color,
								borderRadius: '0 10px 10px 10px',
							}}>
							<CardBody className="py-4 px-2">
								<Text color={item.textColor} size="big" center>
									{`${symbolPriceFormatter(item.value || 0)}`}
								</Text>
							</CardBody>
						</Card>
					</Col>
				))}
			</Row>


			<Row className="mt-5">
				<Col>
					<LoaderLista
						loading={loadingDetalhamento}
						lista={
							dataDetalhamento.dados || []
						}
						error={dataDetalhamento.error || null}>

						{/* Tabela de Listagem */}
						<div className="table-responsive">
							{user.dados.cargo.toLowerCase() !== 'industria'
								?
								<Table id="test-table-xls-button" responsive>
									<thead>
										<TrStyled>
											<th>Revenda</th>
											<th>Split (%)</th>
											<th>Plano</th>
											<th>Data Transação</th>
											<th>Data Agendada</th>
											<th>Transação</th>
											<th>Modalidade</th>
											<th>Taxa</th>
											<th>Credito gerado</th>
											{permissao === 'Participante' &&
												<th>Taxa Distr.</th>
											}
											{user.dados.cargo.toLowerCase() === 'industria'? <th>Receb. Participante</th> : <th>Receb. Distribuidor</th>}
										</TrStyled>
									</thead>
									<tbody>
										{dataDetalhamento.dados && dataDetalhamento.dados.length > 0 && dataDetalhamento.dados.map((item, index) => (
											<tr style={item.modalidade == 'Ajuste a Débito' ? {color: 'red'} : undefined} key={`${item.autorizacao} ${index}`}>
												<td>
													{`${item.documento_revenda ? item.documento_revenda + ' - ' : ''}`} {item.nome_revenda || '-'}
												</td>
												<td>
													{item.split_liquido ?? ''}
												</td>
												<td>
													{item.plano_revenda ? item.plano_revenda : ''}
												</td>
												<td style={{ textAlign: 'center' }}>
													{ item.data ? formatarData(item.data) : '-'}
													<br />
													{item.horario || ''}
												</td>
												<td style={{ textAlign: 'center' }}>
													{ item.data_agendado ? formatarData(item.data_agendado) : (item.data_agendada ? formatarData(item.data_agendada) : '-')}
												</td>
												<td>
													{item.valor ? symbolPriceFormatter(item.valor) : '-'}
												</td>
												<td>
													{item.modalidade.toLowerCase() === 'crédito parcelado' || item.modalidade.toLowerCase() === 'credito parcelado'
														? `Parcelado em ${item.parcelas}x`
														: item.modalidade.toLowerCase() === 'crédito à vista' || item.modalidade.toLowerCase() === 'credito a vista'
															? `Debito à Vista`
															: item.modalidade}
												</td>
												<td>
													{item.modalidade == 'Ajuste a Débito' ? '-' :  `${item.taxa_credito}%`}
												</td>
												<td>
													{item.credito_gerado ? symbolPriceFormatter(item.credito_gerado) : '-'}
												</td>
												{permissao === 'Participante' &&
													<td style={{ textAlign: 'center' }}>
														{item.taxa_participante ? (item.taxa_participante + '%') : item.taxa_distribuidor ? (item.taxa_distribuidor + '%') : '-'}
													</td>
												}
												<td>
													{item.total_rec_participante ? symbolPriceFormatter(item.total_rec_participante) : item.recebimento_distribuidor ? symbolPriceFormatter(item.recebimento_distribuidor) : '-'}
												</td>
											</tr>
										))}

									</tbody>
								</Table>
								:
								<Table id="test-table-xls-button" responsive>
									<thead>
										<TrStyled>
											<th>Documento Distribuidor</th>
											<th>Distribuidor</th>
											<th>Data Transação</th>
											<th>Transação</th>
											<th>Modalidade</th>
											<th>Credito Distribuidor</th>
											<th>Taxa Indústria</th>
											<th>Recebimento Indústria</th>
										</TrStyled>
									</thead>
									<tbody>
										{dataDetalhamento.dados && dataDetalhamento.dados.length > 0 && dataDetalhamento.dados.map((item, index) => (
											<tr key={`${item.autorizacao} ${index}`} style={{color: item.modalidade == 'Ajuste a Débito' ? 'red' : ''}}>
												<td>
													{(item.documento_distribuidor? item.documento_distribuidor : '-')}
												</td>
												<td>
													{(item.nome_distribuidor ? item.nome_distribuidor : '-')}
												</td>
												<td style={{ textAlign: 'center' }}>
													{item.data || '-'}
												</td>
												<td>
													{item.valor ? symbolPriceFormatter(item.valor) : '-'}
												</td>
												<td>
													{item.modalidade || '-'}
												</td>
												<td>
													{item.recebimento_distribuidor ? symbolPriceFormatter(item.recebimento_distribuidor) : '-'}
												</td>
												<td style={{ textAlign: 'center' }}>
													{item.taxa_industria && item.bandeira !== 'AJ' ? item.taxa_industria + '%' : '-'}
												</td>
													<td style={{ textAlign: 'center' }}>
													{item.recebimento_industria ? symbolPriceFormatter(item.recebimento_industria) : '-'}
												</td>
											</tr>
										))}

									</tbody>
								</Table>
							}

						</div>


						<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
							<Pagination
								activePage={pagina}
								totalItemsCount={dataDetalhamento.total_registros ? dataDetalhamento.total_registros : 0}
								onChange={(page) => handlerPagination(page)}
								prevPageText={<ChevronLeftOutlined />}
								nextPageText={<ChevronRightOutlined />}
								firstPageText={<FirstPageOutlined />}
								lastPageText={<LastPageOutlined />}
							/>
						</div>
					</LoaderLista>
				</Col>
			</Row>
		</Container>
	);
}
